import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import config from "config.json";
import { authHeader, authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { HistorialSolicitudesVacacionesTH } from "./TypesHistorialAprovacionesV";
import { handle_error } from "../../DirectivoUnidad/Vacaciones/helper_function";
import { alertService } from "../../Varios/alert_service";

//export async function ObtenerAniosHistorial() {
//    const URL = config.SERVER_URL + "AprobacionTh/HistorialSolicitudesVacaciones/AniosDisponibles"
//    const datosUsuario: UserData = authenticationService.currentUserValue;
//    var resultado: ResponseRequest = { status: -1 }
//    try {
//        const respuesta = await axios.get(URL,
//            {
//                headers: authHeaderWithUserData(datosUsuario)
//            })
//        const datos: number[] = respuesta.data;
//        resultado = { status: respuesta.status, dataResponse: datos }
//    } catch (error) {
//        if (axios.isAxiosError(error) && error.response) {
//            resultado = { status: error.response.status, errorMessage: error.response.data }
//        }
//    }
//    return resultado;
//}

export async function ObtenerHistorial(fechaDesde: Date | null, fechaHasta: Date | null, estadoSolicitud: string, estadoAP: string) {
    var fechaDesdeParse = ""
    var fechaHastaParse = ""

    if (fechaDesde && fechaHasta) {
        fechaDesdeParse = `${fechaDesde.getFullYear()}-${fechaDesde.getMonth() + 1}-${fechaDesde.getDate()}`
        fechaHastaParse = `${fechaHasta.getFullYear()}-${fechaHasta.getMonth() + 1}-${fechaHasta.getDate()}`
    }

    const URL = config.SERVER_URL + "AprobacionTh/HistorialSolicitudesVacaciones"
    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario),
                params: {
                    fechaDesde: fechaDesdeParse,
                    fechaHasta: fechaHastaParse,
                    estadoSolicitud: estadoSolicitud,
                    estadoAP: estadoAP
                }
            })
        const datos: HistorialSolicitudesVacacionesTH[] = respuesta.data;
        resultado = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }
    }
    return resultado;
}

export async function downloadExcelReport(
    fechaDesde: Date | null,
    fechaHasta: Date | null,
    estadoSolicitud: string,
    estadoAP: string
) {
    var currentUser: UserData = authenticationService.currentUserValue;
    if (!currentUser) { return -1 }

    // 1. Construye los query params
    const params = new URLSearchParams();
    if (fechaDesde && fechaHasta) {
        params.append('fechaDesde', `${fechaDesde.getFullYear()}-${fechaDesde.getMonth() + 1}-${fechaDesde.getDate()}`);
        params.append('fechaHasta', `${fechaHasta.getFullYear()}-${fechaHasta.getMonth() + 1}-${fechaHasta.getDate()}`);
    }
    params.append('estadoSolicitud', estadoSolicitud);
    params.append('estadoAP', estadoAP);

    // 2. Agrega los params a la URL
    const url = new URL(config.SERVER_URL + "AprobacionTh/HistorialSolicitudesVacaciones/Reporte");
    url.search = params.toString();

    try {
        const response = await fetch(url.toString(), {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `KEYESPOL ${currentUser?.token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = "Reporte Historial de Solicitudes.xlsx"; // A�ade extensi�n .xlsx
        a.click();
        window.URL.revokeObjectURL(downloadUrl); // Limpia la URL

        return 1;
    } catch (error) {
        const status_code = handle_error(error);
        switch (status_code) {
            case 0:
            case -1:
                alertService.error("No se ha podido establecer contacto con el servidor");
                break;
            case 500:
                alertService.error("Ha ocurrido un error inesperado");
                break;
            default:
                alertService.error("Ha ocurrido un error desconocido");
                break;
        }
        window.scrollTo({ top: 0, behavior: "auto" });
        return -1;
    }
}